import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=fbf60fd4&scoped=true"
import script from "./Assignment.vue?vue&type=script&lang=js"
export * from "./Assignment.vue?vue&type=script&lang=js"
import style0 from "./Assignment.vue?vue&type=style&index=0&id=fbf60fd4&prod&lang=css"
import style1 from "./Assignment.vue?vue&type=style&index=1&id=fbf60fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf60fd4",
  null
  
)

export default component.exports